import React, { useEffect, useState, useCallback } from "react";
import { PARTICULAR_RESPONSE_PARAMETER_LIST_GET } from "../../../api/ApiConst";
import ResponseParameterAddEdit from "./ResponseParameterAddEdit";
import TableFilter from "../../constants/TableFilter";

const ResponseParameters = ({requestId, requestName}) => {
  const [url, setUrl] = useState("");
  const [parameterDrawCount, setParameterDrawCount] = useState(0);
  const [showAddModel, setShowAddModel] = useState(false);
  const [parameterObj, setParameterObj] = useState(null)

  // Show Parameter Add/Edit Model
  const toggleAddModel = () => {
    setShowAddModel((prev) => !prev);
  };

  // Response Parameter Create and Edit
  const handleAddEditResponseParameter = (row = null) => {
    setParameterObj(row);
    toggleAddModel();
  };

  useEffect(() => {
    if (requestId) {
      setUrl(
        PARTICULAR_RESPONSE_PARAMETER_LIST_GET.replaceAll(
          "{request-id}",
          requestId
        )
      );
    }
  }, [requestId]);

  const getParametersTableView = useCallback(() => {
    return (
      <>
        <div className="card">
          <div className="card-body p-0">
            <div className="col-12 table-info">
              <div className="d-flex justify-content-center position-relative">
                <h5 className="d-inline-block m-0">
                  Response {requestName} Parameters
                </h5>
                <button
                  type="button"
                  className="btn btn-primary border-0 new-attribute-btn"
                  onClick={handleAddEditResponseParameter}
                >
                  Add New
                </button>
              </div>
            </div>
            <div className="col-12 mt-3">
              {url !== "" && (
                <TableFilter
                  tableName="response_parameter"
                  tableUrl={url}
                  paginationStatus={false}
                  drawCount={parameterDrawCount}
                  showRecordUpdateModel={handleAddEditResponseParameter}
                  refreshTableData={() => setParameterDrawCount((pre) => pre + 1)}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }, [url, parameterDrawCount]);

  return (
    <>
      {getParametersTableView()}
      {
        <ResponseParameterAddEdit
          isOpen={showAddModel}
          requestId={requestId}
          row={parameterObj}
          onClose={toggleAddModel}
          onSuccessCallBack={() => setParameterDrawCount((pre) => pre + 1)}
        />
      }
    </>
  );
};

export default ResponseParameters;
